import { Routes } from '@angular/router';
import {
  ApplicantDataComponentConfig,
  ApplicantDataSectionComponent
} from '../common/applicant-data-section/applicant-data-section.component';
import {
  ApplicationDataComponentConfig,
  ApplicationDataSectionComponent
} from '../common/application-data-section/application-data-section.component';
import {
  AgreementsDataComponentConfig,
  AgreementsDataSectionComponent
} from '../common/agreements-data-section/agreements-data-section.component';
import {
  AttachmentDataComponentConfig,
  AttachmentsDataSectionComponent
} from '../common/attachments-data-section/attachments-data-section.component';
import {
  DecisionOnDeterminingTheLocationOfAPublicPurposeInvestmentServiceSectionComponent
} from './sections/decision-on-determining-the-location-of-a-public-purpose-investment-service-section/decision-on-determining-the-location-of-a-public-purpose-investment-service-section.component';
import {
  DecisionOnDeterminingTheLocationOfAPublicPurposeInvestmentCharacteristicsSectionComponent
} from './sections/decision-on-determining-the-location-of-a-public-purpose-investment-characteristics-section/decision-on-determining-the-location-of-a-public-purpose-investment-characteristics-section.component';
import {
  DecisionOnDeterminingTheLocationOfAPublicPurposeInvestmentTerrainInfoSectionComponent
} from './sections/decision-on-determining-the-location-of-a-public-purpose-investment-terrain-info-section/decision-on-determining-the-location-of-a-public-purpose-investment-terrain-info-section.component';

export const stages = [
  'Wnioskodawca',
  'Dane wniosku',
  'Teren objęty wnioskiem',
  'Charakterystyka inwestycji',
  'Obsługa komunikacyjna',
  'Zgody',
  'Załączniki'
];

export const applicantDataSectionConfig: ApplicantDataComponentConfig = {
  stages
};

export const applicationDataSectionConfig: ApplicationDataComponentConfig = {
  stages,
  successUrl: '../teren-objety-wnioskiem',
  cancelUrl: '../wnioskodawca',
  addApplicationSubjectControl: true,
  applicationSubjectControlType: 'label',
  applicationSubjectDefaultValue: 'Wniosek o wydanie decyzji o ustalenie lokalizacji inwestycji celu publicznego'
};

export const agreementsDataSectionConfig: AgreementsDataComponentConfig = {
  stages,
  cancelUrl: '../obsluga-komunikacyjna',
  successUrl: '../zalaczniki'
};

export const attachmentDataSectionConfig: AttachmentDataComponentConfig = {
  stages,
  cancelUrl: '../zgody'
};

export const decisionOnDeterminingTheLocationOfAPublicPurposeInvestmentRoutes: Routes = [
  {
    component: ApplicantDataSectionComponent,
    path: 'wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicantDataSectionComponent,
    path: ':appId/wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicationDataSectionComponent,
    path: ':appId/dane-wniosku',
    data: applicationDataSectionConfig
  },
  {
    component: DecisionOnDeterminingTheLocationOfAPublicPurposeInvestmentTerrainInfoSectionComponent,
    path: ':appId/teren-objety-wnioskiem'
  },
  {
    component: DecisionOnDeterminingTheLocationOfAPublicPurposeInvestmentCharacteristicsSectionComponent,
    path: ':appId/charakterystyka-inwestycji'
  },
  {
    component: DecisionOnDeterminingTheLocationOfAPublicPurposeInvestmentServiceSectionComponent,
    path: ':appId/obsluga-komunikacyjna'
  },
  {
    component: AgreementsDataSectionComponent,
    path: ':appId/zgody',
    data: agreementsDataSectionConfig
  },
  {
    component: AttachmentsDataSectionComponent,
    path: ':appId/zalaczniki',
    data: attachmentDataSectionConfig
  },
  { path: '', redirectTo: 'wnioskodawca', pathMatch: 'prefix' }
];
